import { useState } from "react";
import { useSearchParams } from "react-router-dom";

const MY_CHARGE_ONLY_STORAGE_KEY = "smartcta.myChargeOnly";

// "내 담당만 보기" 체크 상태를 localStorage에 남겨서, 탭(통장/카드/매입세금/
// 매출세금/급여관리 등)을 오가며 페이지가 통째로 새로고침돼도 마지막으로
// 선택한 값이 이어지도록 한다. 여러 페이지가 이 키를 공유해야 하므로 훅으로
// 뺐다.
export const useMyChargeOnlyFilter = () => {
  const [isMyChargeOnly, setIsMyChargeOnlyState] = useState(() => {
    try {
      return localStorage.getItem(MY_CHARGE_ONLY_STORAGE_KEY) === "true";
    } catch {
      return false;
    }
  });

  const setIsMyChargeOnly = (checked: boolean) => {
    setIsMyChargeOnlyState(checked);
    try {
      localStorage.setItem(MY_CHARGE_ONLY_STORAGE_KEY, String(checked));
    } catch {
      // localStorage를 쓸 수 없는 환경(프라이빗 모드 등)이면 이번 세션에서만 적용
    }
  };

  return [isMyChargeOnly, setIsMyChargeOnly] as const;
};

export const useCurrentSearchParam = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  const [startDate, endDate] = [
    searchParam.get("startDate"),
    searchParam.get("endDate"),
  ];

  if (startDate && endDate) {
    return { startDate, endDate };
  } else {
    return { startDate: "", endDate: "" };
  }
};
